__turbopack_context__.v({
  "badge": "OtherEntry-module__-LNOaa__badge",
  "badgeBackground__orange": "OtherEntry-module__-LNOaa__badgeBackground__orange",
  "badgeBackground__teal": "OtherEntry-module__-LNOaa__badgeBackground__teal",
  "content": "OtherEntry-module__-LNOaa__content",
  "contentLeft": "OtherEntry-module__-LNOaa__contentLeft",
  "contentText": "OtherEntry-module__-LNOaa__contentText",
  "disableHoverEffects": "OtherEntry-module__-LNOaa__disableHoverEffects",
  "entryBreaker": "OtherEntry-module__-LNOaa__entryBreaker",
  "entryOrange": "OtherEntry-module__-LNOaa__entryOrange",
  "entrySubtitle": "OtherEntry-module__-LNOaa__entrySubtitle",
  "entryTitle": "OtherEntry-module__-LNOaa__entryTitle",
  "entryWrapper": "OtherEntry-module__-LNOaa__entryWrapper",
  "icon": "OtherEntry-module__-LNOaa__icon",
  "iconDeselected": "OtherEntry-module__-LNOaa__iconDeselected",
  "iconSelected": "OtherEntry-module__-LNOaa__iconSelected",
  "increasePadding": "OtherEntry-module__-LNOaa__increasePadding",
  "mainIcon": "OtherEntry-module__-LNOaa__mainIcon",
  "noGap": "OtherEntry-module__-LNOaa__noGap",
  "selected": "OtherEntry-module__-LNOaa__selected",
  "selectedIcon": "OtherEntry-module__-LNOaa__selectedIcon",
});
